import { Component } from '@angular/core';
import {
  SalesRouteFeature,
  SalesRoutePin,
} from '../../../map/features/sales-routes/sales-route-feature';

/**
 * The sales-route layer's control panel: the planned day in order, and a way
 * back to the page that plans it.
 *
 * Like the territory layer, this one draws what its page hands it and fetches
 * nothing, so the panel reads the stops from the feature's Route map object
 * and stays in step with the plan rather than caching a copy that can go stale.
 */
@Component({
  selector: 'app-sales-route-control',
  templateUrl: './sales-route-control.component.html',
  styleUrls: ['./sales-route-control.component.css'],
})
export class SalesRouteControlComponent {
  constructor(private feature: SalesRouteFeature) {}

  get stops(): readonly SalesRoutePin[] {
    return this.feature.objects[0]?.pins ?? [];
  }

  get layerHidden(): boolean {
    return !this.feature.enabled;
  }

}
